import React, { useRef, useState } from "react";
import { Button, message, Modal, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { changeExtensiontoLowerCase } from "../../Common/utils/extraFunctions";

const { Dragger } = Upload;

const ImportErts = ({ 
file,setFile,fileNametext,setFileNametext,uploadTemp,state,setState
}) => {

   const uploadFile = useRef("");

   function beforeUpload(file) {
    const supportedFormats = file?.type;
  
    if (!supportedFormats?.includes("pdf")) {
      message.error("Unsupported file format!");
      return
    }
  
    const isPdf = file.type === "application/pdf";
    const isLt100M = file.size / 1024 / 1024 < 100;
  
    if (!isPdf) {
      message.error("You can only upload PDF file!");
    }
    if (!isLt100M) {
      message.error("File must be smaller than 100MB!");
    }
  
    if (!isPdf || !isLt100M) {
      return Upload.LIST_IGNORE;
    }
  
    // ✅ Confirmation should come AFTER validation but BEFORE upload

    return true; // Allow upload
  }
  
const handleUpload=()=>{
  uploadTemp(false)


}
 
   function bytesToSize(bytes) {
     let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
     if (bytes === 0) return "0 Byte";
     let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
     return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
   }
 
   let handleCustome = (data) => {
     setFileNametext({name:changeExtensiontoLowerCase(data?.file?.name), size:data?.file?.size});
     const formData = new FormData();
     formData.append("file", data?.file);
     const fileName = changeExtensiontoLowerCase(data?.file?.name)
     if (fileName?.includes(".pdf")) {
       formData.append("fileType", "PDF");
     }
     uploadFile.current = formData;
     const reader = new FileReader();
     reader.readAsDataURL(data.file);
     reader.onload = () => {};
     reader.onerror = (error) => {
       return error;
     };
     setFile(data.file);
   };
 

  return (
    <div
      style={{
        width: "100%",
        margin: "auto",
        height:"80%",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Dragger
        accept=".pdf"
        progress={false}
        showUploadList={false}
        customRequest={handleCustome}
        beforeUpload={beforeUpload}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Paste, click, or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single document/pdf upload.
        </p>
      </Dragger>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        {fileNametext?.name && <h3>{fileNametext.name}</h3>}
        {fileNametext?.size && <h6>Size: {bytesToSize(fileNametext.size)}</h6>}
      </div>
      <div style={{display:"flex",justifyContent:"center",width:'100%'}}><Button type={"primary"} disabled={!fileNametext?.size} onClick={handleUpload}>Done</Button></div>
    </div>
  );
};

export {ImportErts}